/**
 * Report Search 页面常量
 */

/** type 标识（全局唯一） */
export const SEARCH_HISTORY_TYPE = 'report-search';

/** 搜索历史最大保存条数 */
export const SEARCH_HISTORY_MAX = 20;

/** 联想搜索建议防抖时间（毫秒） */
export const SUGGEST_DEBOUNCE_MS = 300;

/** 联想建议最大展示条数 */
export const SUGGEST_LIMIT = 10;


/** Report Search 一期覆盖的 system 集合 */
export const REPORT_SEARCH_SYSTEMS = [
  'intelligence_ai',
  'intelligence',
  'intelligence_insights',
  'intelligence_iic',
  'gameResearch',
];

/**
 * 默认页"最新报告"客户端分批渲染参数。
 * 控制单批渲染的卡片数量，从而控制并发的 cover 图片请求量，
 * 避免首屏图片请求排队，导致第一张 cover 长时间不展示。
 */
export const LATEST_INITIAL_BATCH = 20;
export const LATEST_PAGE_SIZE = 20;

/**
 * 默认页"热门报告"客户端分批渲染参数。
 * popular 单条目比 latest 卡片紧凑（横向单行），首屏可多渲染若干条以保证榜单视觉完整；
 * 同时避免一次性挂载几百个 Bubble + useMemo 节点导致首屏阻塞。
 */
export const POPULAR_INITIAL_BATCH = 20;
export const POPULAR_PAGE_SIZE = 20;

